import axios from "axios";
import FeatherIcon from "feather-icons-react";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import Sms from "../sms/Sms";

class Remind extends Component {
    state = {
        sms: true,
        gmail: true,
        chat: "",
        input: [],
        boxes: [],
        allBoxes: [],
        reminds: [],
        search: "",
        error: "",
        loadingBoxes: true,
        loadingReminds: true,
        boxesError: false,
        remindsError: false,
        sending: false,
        deletingId: null
    };

    _isMounted = false;

    componentDidMount() {
        this._isMounted = true;
        this.getBoxes();
        this.getReminds();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getBoxes = async () => {
        this.setState({ loadingBoxes: true, boxesError: false });

        try {
            const response = await axios.get("parentfamilies");
            const families = response.status === 200 && Array.isArray(response.data)
                ? response.data
                : [];
            const knownIds = new Set();
            const boxes = families
                .map((family) => family && family.user)
                .filter((user) => {
                    if (!user || user.id === undefined || knownIds.has(String(user.id))) return false;
                    knownIds.add(String(user.id));
                    return true;
                });

            if (!this._isMounted) return;
            this.setState({
                boxes,
                allBoxes: boxes,
                input: boxes.map((user) => user.id),
                loadingBoxes: false
            });
        } catch (error) {
            if (this._isMounted) this.setState({ loadingBoxes: false, boxesError: true });
        }
    };

    getReminds = async () => {
        this.setState({ loadingReminds: true, remindsError: false });

        try {
            const response = await axios.get("chats");
            const reminds = response.status === 200 && Array.isArray(response.data) ? response.data : [];
            if (this._isMounted) this.setState({ reminds, loadingReminds: false });
        } catch (error) {
            if (this._isMounted) this.setState({ loadingReminds: false, remindsError: true });
        }
    };

    handleInputCocher = () => {
        this.setState(({ input, allBoxes }) => {
            const allSelected = allBoxes.length > 0
                && allBoxes.every((user) => input.some((id) => String(id) === String(user.id)));
            return { input: allSelected ? [] : allBoxes.map((user) => user.id) };
        });
    };

    handleInputSearch = (event) => {
        const search = event.target.value;
        const term = search.trim().toLowerCase();
        const boxes = this.state.allBoxes.filter((user) => [
            user.first_name, user.last_name, user.email, user.tel, user.family_name
        ].some((value) => String(value || "").toLowerCase().includes(term)));
        this.setState({ search, boxes });
    };

    handleInputBox = (boxId) => {
        this.setState(({ input }) => {
            const exists = input.some((id) => String(id) === String(boxId));
            return {
                input: exists
                    ? input.filter((id) => String(id) !== String(boxId))
                    : [...input, boxId]
            };
        });
    };

    storeChat = async (event) => {
        event.preventDefault();
        const chat = this.state.chat.trim();
        if (!chat || this.state.input.length === 0 || this.state.sending) return;
        this.setState({ sending: true, error: "" });

        try {
            const response = await axios.post("chats", {
                gmail: this.state.gmail,
                sms: this.state.sms,
                receverId: this.state.input,
                chat,
                last: 1
            });
            if (!this._isMounted) return;
            this.setState({ chat: "", sending: false });
            await this.getReminds();
            toast(response?.data?.msg || "La notification a \u00e9t\u00e9 envoy\u00e9e.", {
                theme: "light",
                style: { backgroundColor: "var(--ev-primary)", color: "white" }
            });
        } catch (error) {
            if (!this._isMounted) return;
            this.setState({
                error: error?.response?.data?.msg || "Une erreur s'est produite.",
                sending: false
            });
            toast("L'envoi de la notification a \u00e9chou\u00e9.", {
                theme: "light",
                style: { backgroundColor: "#dc2626", color: "white" }
            });
        }
    };

    delete = async (chatId) => {
        if (!window.confirm("Supprimer cette notification de l'historique ?")) return;
        this.setState({ deletingId: chatId });
        try {
            await axios.delete("chats/" + chatId);
            await this.getReminds();
        } catch (error) {
            toast("La suppression a \u00e9chou\u00e9.", { theme: "light" });
        } finally {
            if (this._isMounted) this.setState({ deletingId: null });
        }
    };

    getEstablishment = () => {
        try {
            const profile = JSON.parse(localStorage.getItem("profile") || "{}");
            return profile?.profile?.establishment || {};
        } catch (error) {
            return {};
        }
    };

    getName = (user) => [user.last_name, user.first_name]
        .filter(Boolean).join(" ") || user.family_name || "Parent sans nom";

    getInitials = (user) => [user.last_name, user.first_name]
        .filter(Boolean).map((value) => value.charAt(0)).join("")
        .slice(0, 2).toUpperCase() || "P";

    renderAvatar = (user, className = "") => user.avatar
        ? <img className={className} src={user.avatar} alt="" />
        : <span className={`${className} reminds-avatar-fallback`}>{this.getInitials(user)}</span>;

    render() {
        const {
            allBoxes, boxes, input, reminds, search, chat, loadingBoxes,
            loadingReminds, boxesError, remindsError, sending, deletingId
        } = this.state;
        const establishment = this.getEstablishment();
        const selectedCount = input.length;
        const allSelected = allBoxes.length > 0
            && allBoxes.every((user) => input.some((id) => String(id) === String(user.id)));
        const canSend = chat.trim().length > 0 && selectedCount > 0 && !sending;

        return (
            <main className="reminds-page">
                <Helmet><title>{process.env.REACT_APP_NAME} | Notifications aux parents</title></Helmet>

                <header className="reminds-hero">
                    <div className="reminds-hero__copy">
                        <span>Communication scolaire</span>
                        <h1>Notifier les parents</h1>
                        <p>Pr&eacute;parez une annonce, choisissez ses destinataires et retrouvez les derniers envois.</p>
                    </div>
                    <div className="reminds-hero__stats">
                        <article><FeatherIcon icon="users" size="20" /><div><strong>{selectedCount}</strong><span>s&eacute;lectionn&eacute;{selectedCount > 1 ? "s" : ""}</span></div></article>
                        <article><FeatherIcon icon="send" size="20" /><div><strong>{reminds.length}</strong><span>envoi{reminds.length > 1 ? "s" : ""}</span></div></article>
                    </div>
                </header>

                <section className="reminds-workspace">
                    <aside className="reminds-recipients">
                        <header><div><span>Destinataires</span><h2>Parents et familles</h2></div><small>{allBoxes.length}</small></header>

                        <div className="reminds-search">
                            <FeatherIcon icon="search" size="17" />
                            <input type="search" value={search} onChange={this.handleInputSearch} placeholder="Nom, t&eacute;l&eacute;phone, e-mail..." aria-label="Rechercher un parent" />
                            {search && <button type="button" onClick={() => this.handleInputSearch({ target: { value: "" } })} aria-label="Effacer la recherche"><FeatherIcon icon="x" size="15" /></button>}
                        </div>

                        <div className="reminds-select-all">
                            <label><input type="checkbox" checked={allSelected} onChange={this.handleInputCocher} /><span>Tout s&eacute;lectionner</span></label>
                            <small>{selectedCount}/{allBoxes.length}</small>
                        </div>

                        <div className="reminds-recipient-list">
                            {loadingBoxes && <div className="reminds-state compact"><FeatherIcon className="reminds-spin" icon="loader" /><p>Chargement des parents...</p></div>}
                            {!loadingBoxes && boxesError && <div className="reminds-state compact error"><FeatherIcon icon="alert-circle" /><p>Impossible de charger les parents.</p><button type="button" onClick={this.getBoxes}>R&eacute;essayer</button></div>}
                            {!loadingBoxes && !boxesError && boxes.length === 0 && <div className="reminds-state compact"><FeatherIcon icon={search ? "search" : "users"} /><p>{search ? "Aucun parent ne correspond." : "Aucun parent enregistr\u00e9."}</p></div>}
                            {!loadingBoxes && !boxesError && boxes.slice().sort((a, b) => this.getName(a).localeCompare(this.getName(b))).map((box) => {
                                const checked = input.some((id) => String(id) === String(box.id));
                                return (
                                    <label className={`reminds-recipient ${checked ? "selected" : ""}`} key={box.id}>
                                        {this.renderAvatar(box, "reminds-avatar")}
                                        <span className="reminds-recipient__identity"><strong>{this.getName(box)}</strong><small>{box.tel || box.email || box.family_name || "Coordonn\u00e9es non renseign\u00e9es"}</small></span>
                                        <input type="checkbox" checked={checked} onChange={() => this.handleInputBox(box.id)} aria-label={`S\u00e9lectionner ${this.getName(box)}`} />
                                        <span className="reminds-check"><FeatherIcon icon="check" size="13" /></span>
                                    </label>
                                );
                            })}
                        </div>
                    </aside>

                    <section className="reminds-panel">
                        <header className="reminds-panel__header">
                            <div className="reminds-school">
                                {establishment.logo ? <img src={establishment.logo} alt="" /> : <span><FeatherIcon icon="home" size="19" /></span>}
                                <div><strong>{establishment.name || "\u00c9tablissement"}</strong><small>Centre de notifications</small></div>
                            </div>
                            <span className="reminds-live"><i /> Diffusion</span>
                        </header>

                        <div className="reminds-history">
                            <div className="reminds-history__title">
                                <div><span>Historique</span><h2>Derni&egrave;res notifications</h2></div>
                                <button type="button" onClick={this.getReminds} disabled={loadingReminds} title="Actualiser"><FeatherIcon icon="refresh-cw" size="16" /></button>
                            </div>
                            {loadingReminds && <div className="reminds-state"><FeatherIcon className="reminds-spin" icon="loader" /><p>Chargement de l'historique...</p></div>}
                            {!loadingReminds && remindsError && <div className="reminds-state error"><FeatherIcon icon="alert-circle" /><h3>Historique indisponible</h3><p>V&eacute;rifiez la connexion puis r&eacute;essayez.</p><button type="button" onClick={this.getReminds}>R&eacute;essayer</button></div>}
                            {!loadingReminds && !remindsError && reminds.length === 0 && <div className="reminds-state"><FeatherIcon icon="bell" /><h3>Aucune notification envoy&eacute;e</h3><p>Votre premi&egrave;re annonce appara&icirc;tra ici.</p></div>}
                            {!loadingReminds && !remindsError && reminds.length > 0 && (
                                <div className="reminds-history__list">
                                    {reminds.map((remind) => {
                                        const recipients = Array.isArray(remind.userchats) ? remind.userchats.length : 0;
                                        return (
                                            <article className="reminds-message" key={remind.id}>
                                                <span className="reminds-message__icon"><FeatherIcon icon="bell" size="17" /></span>
                                                <div className="reminds-message__body">
                                                    <p>{remind.chat}</p>
                                                    <footer>
                                                        <span><FeatherIcon icon="users" size="13" /> {recipients} destinataire{recipients > 1 ? "s" : ""}</span>
                                                        {remind.sms && <span><FeatherIcon icon="message-square" size="13" /> SMS</span>}
                                                        {remind.gmail && <span><FeatherIcon icon="mail" size="13" /> E-mail</span>}
                                                        <time>{new Date(remind.createdAt).toLocaleString("fr-FR")}</time>
                                                    </footer>
                                                </div>
                                                <button type="button" className="reminds-delete" onClick={() => this.delete(remind.id)} disabled={deletingId === remind.id} title="Supprimer"><FeatherIcon icon={deletingId === remind.id ? "loader" : "trash-2"} size="16" /></button>
                                            </article>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        <form className="reminds-composer" onSubmit={this.storeChat}>
                            <div className="reminds-composer__top">
                                <div><span>Nouvelle annonce</span><strong>{selectedCount > 0 ? `${selectedCount} destinataire${selectedCount > 1 ? "s" : ""}` : "Aucun destinataire"}</strong></div>
                                <div className="reminds-channels" aria-label="Canaux d'envoi">
                                    <label className={this.state.sms ? "active" : ""}><input type="checkbox" checked={this.state.sms} onChange={() => this.setState(({ sms }) => ({ sms: !sms }))} /><FeatherIcon icon="message-square" size="15" /> SMS</label>
                                    <label className={this.state.gmail ? "active" : ""}><input type="checkbox" checked={this.state.gmail} onChange={() => this.setState(({ gmail }) => ({ gmail: !gmail }))} /><FeatherIcon icon="mail" size="15" /> E-mail</label>
                                </div>
                            </div>
                            <textarea value={chat} onChange={(event) => this.setState({ chat: event.target.value, error: "" })} placeholder="R&eacute;digez l'information &agrave; transmettre aux parents..." rows="4" maxLength="1000" />
                            <div className="reminds-composer__footer">
                                <span className={this.state.error ? "error" : ""}>{this.state.error || `${chat.length}/1000 caract\u00e8res`}</span>
                                <button type="submit" disabled={!canSend}><FeatherIcon icon={sending ? "loader" : "send"} size="17" />{sending ? "Envoi..." : "Envoyer la notification"}</button>
                            </div>
                        </form>
                    </section>
                </section>
                <br />
                <br />
                <br />
                <section className="reminds-worksheet">
                    <Sms />
                </section>
            </main>
        );
    }
}

export default Remind;
